import { render, staticRenderFns } from "./CoreProgramCampaignStep4.vue?vue&type=template&id=0c621d8c&scoped=true&"
import script from "./CoreProgramCampaignStep4.vue?vue&type=script&lang=js&"
export * from "./CoreProgramCampaignStep4.vue?vue&type=script&lang=js&"
import style0 from "./CoreProgramCampaignStep4.vue?vue&type=style&index=0&id=0c621d8c&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c621d8c",
  null
  
)

export default component.exports